import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
export const AdCarousel = ({ hideOnMobile, hideOnDesktop, itemsInViewDesktop, children, }) => {
    const carouselTranslations = useFreddyTranslations('carousel');
    return (_jsx(Carousel, { hideUntil: hideOnMobile ? 'md' : undefined, hideFrom: hideOnDesktop ? 'md' : undefined, itemsInView: {
            xs: 1.2,
            sm: 1.5,
            md: itemsInViewDesktop,
        }, hideNavigation: true, fullWidthUntil: "md", m: 0, translations: carouselTranslations, children: children }));
};
//# sourceMappingURL=AdCarousel.js.map